import React, { useState, useEffect } from "react";
import { BlackAndWhite } from "../../../../../../../../themes/Colors";
import { PromotionCategoryCard } from "./components";
import { BaseButtons } from "../../../../../../../../components/atoms";
import { Bar, Pie, Line, Stacked, Doughnut } from "react-chartjs-2";

const StaffListDisplay = ({
  item,
  index,
  setSelectedIndex,
  selectedIndex,
  promotionArray,
  promotionCategory,
  dateSelection,
  dateArray,
  receiptList,
}) => {
  const [openStats, setOpenStats] = useState(false);
  const [hover, setHover] = useState(false);

  const [viewGraphs, setViewGraphs] = useState(false);
  const [selectedPromotion, setSelectedPromotion] = useState("all");

  const [promotionArraySearch, setPromotionArraySearch] = useState(null);

  const [refresh, setRefresh] = useState(false);
  //   console.log("index", selectedIndex, "index", index);
  //   console.log("promotionCategory", promotionCategory);
  //   console.log("dateSelection", dateSelection, dateArray);
  //   console.log("promotionArray", promotionArray);
  //   console.log("item", item);

  // grneral graph braek down of data to display promortion on each date thats in the array
  const generalCategoryDisplayTotals = () => {
    console.log("total");
  };

  // then a block view for a quick over view for taotlas of the period and amount
  //   console.log("date array", dateArray[0]);
  //   console.log("receiptList", receiptList);
  const itemGraphCreate = ({ date }) => {
    let stock = 0;

    let promotionArrayNew = [];

    let promotionArrayItem = [];

    let promotionTotal = [];
    let countTotal = [];
    // console.log("promotionName", promotionName);
    // console.log("staffMemebr", staffMemebr);
    // if (promotionArray) {
    //   promotionArray.map(
    //     (promo) =>
    //       console.log(
    //         "promotionName",
    //         promotionName,
    //         promo.promotion.promotionName
    //       )
    //     // item.promotion.promotionName === promotionName &&
    //     // staffMemebr === item.staffMember
    //     //   ? promotionArrayNew.push(item)
    //     //   : null
    //   );
    // }

    // console.log("promotionArrayNew", promotionArrayNew);
    for (let index = 0; index < promotionArraySearch.length; index++) {
      const element = promotionArraySearch[index];

      if (date === element.date) {
        promotionTotal.push(Number(element.promotion.promotion.discountAmount));
      }
    }

    let promotionsTotalAmountCheck = promotionTotal.reduce(function (x, y) {
      return x + y;
    }, 0);

    return {
      promotionTotal: Number(promotionsTotalAmountCheck).toFixed(2),
      Date: date,
    };
  };

  const dataArrayDisplay = () => {
    let arrayAmount = [];
    let completeArray = [];
    let dateArrayCheck = [];

    for (let index = 0; index < dateArray.length; index++) {
      const element = dateArray[index];

      arrayAmount.push(
        Number(
          itemGraphCreate({ date: element.substring(0, 10) }).promotionTotal
        )
      );
      dateArrayCheck.push(
        itemGraphCreate({ date: element.substring(0, 10) }).Date
      );
      completeArray.push(itemGraphCreate({ date: element.substring(0, 10) }));
    }

    return {
      arrayAmount: arrayAmount,
      dateArray: dateArrayCheck,
      completeArray: completeArray,
    };
  };

  const graphArrayData = ({ date, promotionName, staffMemebr }) => {
    let stock = 0;
    setPromotionArraySearch(null);

    let promotionArrayNew = [];

    let promotionArrayItem = [];

    let promotionTotal = [];
    let countTotal = [];
    // console.log("promotionName", promotionName);
    // console.log("staffMemebr", staffMemebr);
    // if (promotionArray) {
    //   promotionArray.map(
    //     (promo) =>
    //       console.log(
    //         "promotionName",
    //         promotionName,
    //         promo.promotion.promotionName
    //       )
    //     // item.promotion.promotionName === promotionName &&
    //     // staffMemebr === item.staffMember
    //     //   ? promotionArrayNew.push(item)
    //     //   : null
    //   );
    // }

    // console.log("promotionArrayNew", promotionArrayNew);
    for (let index = 0; index < promotionArray.length; index++) {
      const element = promotionArray[index];

      if (
        element.promotion.promotionName === promotionName &&
        staffMemebr === element.staffMember
      ) {
        receiptList.map((item) =>
          item.slipNo === element.slipNo
            ? promotionArrayItem.push({
                promotion: element,
                date: item.dateTime.substring(0, 10),
                receipt: item,
              })
            : null
        );
        promotionTotal.push(Number(element.promotion.discountAmount));
      }
    }

    setPromotionArraySearch(promotionArrayItem);
    let promotionsTotalAmountCheck = promotionTotal.reduce(function (x, y) {
      return x + y;
    }, 0);

    return {
      promotionTotal: Number(promotionsTotalAmountCheck).toFixed(2),
      Date: date,
      promotionArrayItem: promotionArrayItem,
    };
  };

  const ReturnPromotionsTotalUsed = ({ promotionName, staffMemebr }) => {
    let stock = 0;

    let promotionArrayNew = [];

    let promotionArrayItem = [];

    let promotionTotal = [];
    let countTotal = [];
    // console.log("promotionName", promotionName);
    // console.log("staffMemebr", staffMemebr);
    // if (promotionArray) {
    //   promotionArray.map(
    //     (promo) =>
    //       console.log(
    //         "promotionName",
    //         promotionName,
    //         promo.promotion.promotionName
    //       )
    //     // item.promotion.promotionName === promotionName &&
    //     // staffMemebr === item.staffMember
    //     //   ? promotionArrayNew.push(item)
    //     //   : null
    //   );
    // }

    // console.log("promotionArrayNew", promotionArrayNew);
    for (let index = 0; index < promotionArray.length; index++) {
      const element = promotionArray[index];
      if (
        element.promotion.promotionName === promotionName &&
        staffMemebr === element.staffMember
      ) {
        promotionTotal.push(Number(element.promotion.discountAmount));
        promotionArrayItem.push(element);
      }
    }

    let promotionsTotalAmountCheck = promotionTotal.reduce(function (x, y) {
      return x + y;
    }, 0);

    return {
      promotionTotal: Number(promotionsTotalAmountCheck).toFixed(2),
      count: promotionTotal.length,
      array: promotionArrayItem,
    };
  };

  const ReturnPromotionsTotalUsedOverall = ({ staffMember }) => {
    let stock = 0;

    let promotionArrayNew = [];

    let promotionTotal = [];
    let countTotal = [];
    // console.log("promotionName", promotionName);
    // console.log("staffMemebr", staffMemebr);
    // if (promotionArray) {
    //   promotionArray.map(
    //     (promo) =>
    //       console.log(
    //         "promotionName",
    //         promotionName,
    //         promo.promotion.promotionName
    //       )
    //     // item.promotion.promotionName === promotionName &&
    //     // staffMemebr === item.staffMember
    //     //   ? promotionArrayNew.push(item)
    //     //   : null
    //   );
    // }

    // console.log("promotionArrayNew", promotionArrayNew);
    for (let index = 0; index < promotionArray.length; index++) {
      const element = promotionArray[index];
      if (staffMember === element.staffMember) {
        promotionTotal.push(Number(element.promotion.discountAmount));
      }
    }

    let promotionsTotalAmountCheck = promotionTotal.reduce(function (x, y) {
      return x + y;
    }, 0);
    // console.log("promotionsTotalAmountCheck", promotionsTotalAmountCheck);
    return {
      promotionTotal: Number(promotionsTotalAmountCheck).toFixed(2),
      count: promotionTotal.length,
    };
  };

  const data = {
    labels: promotionArraySearch ? dataArrayDisplay().dateArray : ["loading"],
    datasets: [
      {
        label: "Discount report", // Setting up the label for the dataset
        labels: promotionArraySearch
          ? dataArrayDisplay().dateArray
          : ["loading"],
        backgroundColor: ["#6792AC"], // Setting up the background color for the dataset
        borderColor: ["#6792AC"], // Setting up the border color for the dataset
        data: promotionArraySearch
          ? dataArrayDisplay().arrayAmount
          : ["loading"],

        // Setting up the data for the dataset
      },
      // {
      //   label: "Sales report", // Setting up the label for the dataset
      //   labels: ["test"],
      //   backgroundColor: [
      //     "#48A14D",
      //     "#008080",
      //     "#B33F40",
      //     "#049BE5",
      //     "#9E3AC3",
      //   ], // Setting up the background color for the dataset
      //   borderColor: ["#48A14D", "#008080", "#B33F40", "#049BE5", "#9E3AC3"], // Setting up the border color for the dataset
      //   data: [
      //     11000, 3000, 350, 4090, 2000, 6000, 700, 12000, 800, 3000, 11000,
      //     3000, 350, 4090, 2000, 6000, 700, 12000, 800, 3000, 11000, 3000, 350,
      //     4090, 2000, 6000, 700, 12000, 800, 3000,
      //   ],

      //   // Setting up the data for the dataset
      // },
    ],
  };

  useEffect(() => {
    if (selectedPromotion && dateArray && promotionArraySearch) {
      //   itemGraphCreate({ date: dateArray[2].substring(0, 10) });
      dataArrayDisplay();
    }
  }, [selectedPromotion]);
  return (
    <div
      onMouseOver={() => setHover(true)}
      onMouseOut={() => setHover(false)}
      style={{
        width: "100%",
        borderBottomStyle:
          openStats && Number(selectedIndex) === Number(index)
            ? "solid"
            : "none",
        borderBottomWidth:
          openStats && Number(selectedIndex) === Number(index) ? 1 : 0,
        height: openStats && Number(selectedIndex) === Number(index) ? 390 : 40,
        display: "flex",
        alignItems: "center",
        borderColor:
          openStats && Number(selectedIndex) === Number(index)
            ? "#00000050"
            : null,

        flexDirection: "column",
      }}
    >
      <div
        onClick={() => {
          setOpenStats(openStats ? false : true);
          setSelectedIndex(index);
        }}
        style={{
          fontWeight: "bold",
          width: "100%",
          borderBottomStyle: "solid",
          borderBottomWidth: 1,
          height: 40,
          display: "flex",
          alignItems: "center",
          borderColor: "#00000050",
          backgroundColor:
            Number(selectedIndex) === Number(index)
              ? BlackAndWhite.red50
              : hover
              ? BlackAndWhite.red50
              : BlackAndWhite.secondary,
        }}
      >
        <div style={{ marginLeft: 10 }}>
          {item.firstName + " " + item.lastName}
        </div>
        <div style={{ flex: 1 }} />
        {openStats && Number(selectedIndex) === Number(index) ? (
          <div
            style={{ marginRight: 10, display: "flex", alignItems: "center" }}
          >
            Date:{" "}
            <div style={{ marginLeft: 10, marginRight: 10 }}>
              {dateSelection}
            </div>{" "}
            Total discounted : R{" "}
            <div style={{ marginLeft: 10, fontWeight: "bold" }}>
              {" "}
              {
                ReturnPromotionsTotalUsedOverall({
                  staffMember: item.firstName + " " + item.lastName,
                }).promotionTotal
              }
            </div>
          </div>
        ) : (
          <div
            style={{
              marginRight: 10,
              fontWeight: "normal",
              display: "flex",
              alignItems: "center",
            }}
          >
            Total discounted : R{" "}
            <div style={{ marginLeft: 10, fontWeight: "bold" }}>
              {" "}
              {
                ReturnPromotionsTotalUsedOverall({
                  staffMember: item.firstName + " " + item.lastName,
                }).promotionTotal
              }
            </div>
          </div>
        )}
      </div>
      <div
        style={{
          height:
            openStats && Number(selectedIndex) === Number(index) ? 350 : 0,
          width: "100%",
          //   borderStyle: "solid",
          overflow: "hidden",
          transition: "all 0.2s",
          display: "flex",
          alignItems: "center",
          position: "relative",
        }}
      >
        <div
          style={{ display: "flex", position: "absolute", top: 10, right: 10 }}
        >
          <BaseButtons
            label={"GRAPHS"}
            mini={true}
            marginTopFalse={true}
            height={40}
            onClick={() => setViewGraphs(true)}
            invert={!viewGraphs}
            disable={!selectedPromotion}
          />
          <BaseButtons
            label={"LIST"}
            mini={true}
            marginTopFalse={true}
            height={40}
            onClick={() => {
              setViewGraphs(false);
              setSelectedPromotion(null);
            }}
            invert={viewGraphs}
          />
        </div>
        <div
          style={{ display: "flex", position: "absolute", top: 20, left: 10 }}
        >
          {viewGraphs ? null : (
            <div>
              Click on a promotion card to view a break down on the data over
              the period...
            </div>
          )}
        </div>
        <div
          style={{
            width: "100%",
            height: "100%",
            overflowX: "scroll",
            overflowY: "hidden",
            display: "flex",
            alignItems: "center",
            scrollbarWidth: "thin",
          }}
        >
          {viewGraphs ? (
            <Bar
              //   width={"100%"}
              height={70}
              //   options={}
              data={data}
              // style={{ height: 300, width: "20%" }}
            />
          ) : promotionCategory ? (
            promotionCategory.map((cate, index) => {
              return (
                <div key={index}>
                  <PromotionCategoryCard
                    onClick={() => {
                      setSelectedPromotion(cate);
                      graphArrayData({
                        promotionName: cate.promotionName,
                        staffMemebr: item.firstName + " " + item.lastName,
                        date: dateArray[0].substring(0, 10),
                      });
                      setViewGraphs(true);
                    }}
                    name={cate.promotionName}
                    ReturnPromotionsTotalUsed={ReturnPromotionsTotalUsed}
                    amount={
                      "R" +
                      ReturnPromotionsTotalUsed({
                        promotionName: cate.promotionName,
                        staffMemebr: item.firstName + " " + item.lastName,
                      }).promotionTotal
                    }
                    count={
                      ReturnPromotionsTotalUsed({
                        promotionName: cate.promotionName,
                        staffMemebr: item.firstName + " " + item.lastName,
                      }).count
                    }
                    discountAmount={"R" + cate.discountAmount}
                    marginRight={
                      promotionCategory.length - 1 === index ? 20 : null
                    }
                  />
                </div>
              );
            })
          ) : (
            <div>LOADING</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StaffListDisplay;
